import { type ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CampaignEditor } from '@/components/wizard/campaigns/campaign-editor';
import { loadNamespaces } from '@/lib/i18n/i18n';

// `focus` carries the invalid sitelink URL to open + highlight when the user
// clicks an item in the review screen's invalid-URL banner.
const searchSchema = z.object({
  focus: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/wizard/campaigns/$strategyId/$campaignIndex',
)({
  loader: () => loadNamespaces('assets', 'audiences'),
  validateSearch: searchSchema,
  component: CampaignEditorRoute,
});

function CampaignEditorRoute(): ReactElement {
  const { strategyId, campaignIndex } = Route.useParams();
  const { focus } = Route.useSearch();
  const index = Number.parseInt(campaignIndex, 10);
  return (
    <CampaignEditor
      strategyId={Number(strategyId)}
      campaignIndex={Number.isNaN(index) ? 0 : index}
      focusUrl={focus}
    />
  );
}
